import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Admin from './pages/AdminLogin';
import ClienteAuth from './pages/ClienteAuth';
import ClienteHome from './pages/ClienteHome';
import AdminHome from './pages/AdminHome';
import CadastroLocCasa from './pages/CadastroLocCasa';
import BuscaImoveis from './pages/BuscaImoveis';
import DetalheImovel from './pages/DetalheImovel';
import RedefinirSenha from './pages/RedefinirSenha';
import RotaPrivada from './components/RotaPrivada/RotaPrivada';
import RotaCliente from './components/RotaCliente/RotaCliente';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imoveis" element={<BuscaImoveis />} />
          <Route path="/imoveis/:id" element={<DetalheImovel />} />
          <Route path="/cliente" element={<ClienteAuth />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route
            path="/cliente/home"
            element={
              <RotaCliente>
                <ClienteHome />
              </RotaCliente>
            }
          />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="/form_loc_casa"
            element={
              <RotaCliente>
                <CadastroLocCasa />
              </RotaCliente>
            }
          />
          <Route
            path="/admin/home"
            element={
              <RotaPrivada>
                <AdminHome />
              </RotaPrivada>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;